module.exports = __webpack_public_path__ + "static/avatar-d6c77ac394b2e47b4c6f27ab0e425a90.jpg";